function validateNode(node) {
  return (
    node && node.childMarkdownRemark && node.childMarkdownRemark.html !== ``
  );
}
export default validateNode;
